import { FeatureScope } from "healthex-common/feature-enablement.utils";
export function featureScopeCellState(record) {
    if (!record) {
        return "unset";
    }
    return record.enabled ? "enabled" : "disabled";
}
export function formatFeatureScopeColumnHeaderTooltip(column, scopeNames) {
    switch (column) {
        case FeatureScope.GLOBAL:
            return `Global enablement`;
        case FeatureScope.ORGANIZATION:
            return scopeNames.organizationName ? `Organization enablement for ${scopeNames.organizationName}` : `Organization enablement`;
        case FeatureScope.PATIENT:
            return scopeNames.patientName ? `Patient enablement for ${scopeNames.patientName}` : `Patient enablement`;
    }
}
export function formatFeatureScopeCellTooltip(column, record, scopeNames, isResolved) {
    var _a, _b;
    const state = featureScopeCellState(record);
    const resolvedSuffix = isResolved ? ` · Resolved here` : ``;
    if (column === FeatureScope.GLOBAL) {
        if (state === "unset") {
            return `No global enablement set${resolvedSuffix}`;
        }
        return state === "enabled" ? `Globally enabled${resolvedSuffix}` : `Globally disabled${resolvedSuffix}`;
    }
    const name = column === FeatureScope.ORGANIZATION ? (_a = scopeNames.organizationName) !== null && _a !== void 0 ? _a : `organization` : (_b = scopeNames.patientName) !== null && _b !== void 0 ? _b : `patient`;
    if (state === "unset") {
        return `No enablement set for ${name}${resolvedSuffix}`;
    }
    return state === "enabled" ? `Enabled for ${name}${resolvedSuffix}` : `Disabled for ${name}${resolvedSuffix}`;
}
